import AIClub_GIF from '../assets/graphics/gif/aiclub.gif';
import Club_GIF from '../assets/graphics/gif/club.gif';
import Farmland_GIF from '../assets/graphics/gif/farmland.gif';
import NameCard_GIF from '../assets/graphics/gif/namecard.gif';
import Donation_01_Bread from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_01_bread.jpg';
import Donation_01_Giving from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_01_giving.jpg';
import Donation_01_Hungry from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_01_hungry.jpg';
import Donation_01_Staff from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_01_staff.jpg';
import Donation_02_Bread from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_02_bread.jpg';
import Donation_02_Giving from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_02_giving.jpg';
import Donation_02_Hungry from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_02_hungry.jpg';
import Donation_02_Staff from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_02_staff.jpg';
import Donation_03_Bread from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_03_bread.jpg';
import Donation_03_Giving from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_03_giving.jpg';
import Donation_03_Hungry from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_03_hungry.jpg';
import Donation_03_Staff from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_03_staff.jpg';
import Donation_04_Bread from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_04_bread.jpg';
import Donation_04_Giving from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_04_giving.jpg';
import Donation_04_Hungry from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_04_hungry.jpg';
import Donation_04_Staff from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_04_staff.jpg';
import Donation_05_Bread from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_05_bread.jpg';
import Donation_05_Giving from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_05_giving.jpg';
import Donation_05_Hungry from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_05_hungry.jpg';
import Donation_05_Staff from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_05_staff.jpg';
import Donation_06_Bread from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_06_bread.jpg';
import Donation_06_Giving from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_06_giving.jpg';
import Donation_06_Hungry from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_06_hungry.jpg';
import Donation_06_Staff from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_06_staff.jpg';
import Donation_07_Bread from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_07_bread.jpg';
import Donation_07_Giving from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_07_giving.jpg';
import Donation_07_Hungry from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_07_hungry.jpg';
import Donation_07_Staff from '../assets/graphics/joyajoy/donate-bread/JOYAJOY_DonationPhoto_07_staff.jpg';
import For_web_video_preview_AIMemoryBoosterGuide_EN from '../assets/graphics/joyajoy/For_web_video_preview_AIMemoryBoosterGuide_EN.png';
import For_web_video_preview_AIMemoryBoosterGuide_TC from '../assets/graphics/joyajoy/For_web_video_preview_AIMemoryBoosterGuide_TC.png';
import For_web_video_preview_BibleBoosterGuide_EN from '../assets/graphics/joyajoy/For_web_video_preview_BibleBoosterGuide_EN.png';
import For_web_video_preview_BibleBoosterGuide_TC from '../assets/graphics/joyajoy/For_web_video_preview_BibleBoosterGuide_TC.png';
import For_web_video_preview_Case_Study_SC from '../assets/graphics/joyajoy/For_web_video_preview_CaseStudy_SC.png';
import For_web_video_preview_Case_Study_TC from '../assets/graphics/joyajoy/For_web_video_preview_CaseStudy_TC.png';
import For_web_video_preview_Smart_Parent_Program_EN from '../assets/graphics/joyajoy/For_web_video_preview_Smart_Parent_Program_EN.jpg';
import For_web_video_preview_Smart_Parent_Program_SC from '../assets/graphics/joyajoy/For_web_video_preview_Smart_Parent_Program_SC.jpg';
import For_web_video_preview_Smart_Parent_Program_TC from '../assets/graphics/joyajoy/For_web_video_preview_Smart_Parent_Program_TC.jpg';
import For_web_video_preview_Text_To_Game_EN from '../assets/graphics/joyajoy/For_web_video_preview_Text_To_Game_EN.jpg';
import For_web_video_preview_Text_To_Game_SC from '../assets/graphics/joyajoy/For_web_video_preview_Text_To_Game_SC.jpg';
import For_web_video_preview_Text_To_Game_TC from '../assets/graphics/joyajoy/For_web_video_preview_Text_To_Game_TC.jpg';
import Icon_JOYAJOY_Website_Bot_AIRevisionSystem_EN from '../assets/graphics/joyajoy/icon_JOYAJOY_Website_Bot_AIRevisionSystem.png';
import Icon_JOYAJOY_Website_Bot_AIRevisionSystem_JP from '../assets/graphics/joyajoy/icon_JOYAJOY_Website_Bot_AIRevisionSystem_JP.png';
import Icon_JOYAJOY_Website_Bot_AIRevisionSystem_SC from '../assets/graphics/joyajoy/icon_JOYAJOY_Website_Bot_AIRevisionSystem_SC.png';
import Icon_JOYAJOY_Website_Bot_AIRevisionSystem_TC from '../assets/graphics/joyajoy/icon_JOYAJOY_Website_Bot_AIRevisionSystem_TC.png';
import JOYAJOY_logo from '../assets/graphics/joyajoy/JOYAJOY_logo_ai_2024.png';
import JOYAJOY_logo_Horizontal_Logo_Slogan_ForDarkBG_EN from '../assets/graphics/joyajoy/JOYAJOY_logo_ai_2024_Horizontal_Logo_Slogan_ForDarkBG.png';
import JOYAJOY_logo_Horizontal_Logo_Slogan_ForDarkBG_JP from '../assets/graphics/joyajoy/JOYAJOY_logo_ai_2024_Horizontal_Logo_Slogan_ForDarkBG_JP.png';
import JOYAJOY_logo_Horizontal_Logo_Slogan_ForDarkBG_SC from '../assets/graphics/joyajoy/JOYAJOY_logo_ai_2024_Horizontal_Logo_Slogan_ForDarkBG_SC.png';
import JOYAJOY_logo_Horizontal_Logo_Slogan_ForDarkBG_TC from '../assets/graphics/joyajoy/JOYAJOY_logo_ai_2024_Horizontal_Logo_Slogan_ForDarkBG_TC.png';
import JoyajoyDarkModeLogo from '../assets/graphics/joyajoy/JOYAJOY_logo_ai_2024_Text_ForDarkBG.svg';
import JoyajoyDarkModeNoRLogo from '../assets/graphics/joyajoy/JOYAJOY_logo_ai_2024_Text_ForDarkBG_NoR.svg';
import JOYAJOY_logo_Text_Slogan_EN from '../assets/graphics/joyajoy/JOYAJOY_logo_ai_2024_Text_Slogan.png';
import JOYAJOY_logo_Text_Slogan_JP from '../assets/graphics/joyajoy/JOYAJOY_logo_ai_2024_Text_Slogan_JP.png';
import JOYAJOY_logo_Text_Slogan_SC from '../assets/graphics/joyajoy/JOYAJOY_logo_ai_2024_Text_Slogan_SC.png';
import JOYAJOY_logo_Text_Slogan_TC from '../assets/graphics/joyajoy/JOYAJOY_logo_ai_2024_Text_Slogan_TC.png';
import JoyajoyLightModeLogo from '../assets/graphics/joyajoy/JOYAJOY_logo_ai_2024_Text_WhiteStroke.svg';
import JoyajoyLightModeNoRLogo from '../assets/graphics/joyajoy/JOYAJOY_logo_ai_2024_Text_WhiteStroke_NoR.svg';
import Guide_01 from '../assets/graphics/jpeg/Export_for_guide/Guide_01.jpg';
import Guide_02 from '../assets/graphics/jpeg/Export_for_guide/Guide_02.jpg';
import Guide_03 from '../assets/graphics/jpeg/Export_for_guide/Guide_03.jpg';
import Guide_04 from '../assets/graphics/jpeg/Export_for_guide/Guide_04.jpg';
import GuideAn_01 from '../assets/graphics/jpeg/Export_for_guide/GuideAn_01.jpg';
import GuideAn_02 from '../assets/graphics/jpeg/Export_for_guide/GuideAn_02.jpg';
import GuideAn_03 from '../assets/graphics/jpeg/Export_for_guide/GuideAn_03.jpg';
import GuideAn_04 from '../assets/graphics/jpeg/Export_for_guide/GuideAn_04.jpg';
import GuideAn_05 from '../assets/graphics/jpeg/Export_for_guide/GuideAn_05.jpg';
import QuickHandwritingJOY_01 from '../assets/graphics/jpeg/memoryGames/QuickHandwritingJOY_New_01.jpg';
import QuickHandwritingJOY_02 from '../assets/graphics/jpeg/memoryGames/QuickHandwritingJOY_New_02.jpg';
import QuickMemoryJOY_01 from '../assets/graphics/jpeg/memoryGames/QuickMemoryJOY_01.jpg';
import QuickMemoryJOY_02 from '../assets/graphics/jpeg/memoryGames/QuickMemoryJOY_02.jpg';
import QuickMemoryJOY_03 from '../assets/graphics/jpeg/memoryGames/QuickMemoryJOY_03.jpg';
import QuickMemoryJOY_04 from '../assets/graphics/jpeg/memoryGames/QuickMemoryJOY_04.jpg';
import SpellingJOYByLetters_01 from '../assets/graphics/jpeg/memoryGames/SpellingJOYByLetters_01.jpg';
import SpellingJOYBySyllables_01 from '../assets/graphics/jpeg/memoryGames/SpellingJOYBySyllables_01.jpg';
import ForSmartParentsReferralPrice_EN_CNY from '../assets/graphics/jpeg/smartParentsReferralRewardPrice/GuaranteedLearning_ReferralTable_EN_CNY.jpg';
import ForSmartParentsReferralPrice_EN_HKD from '../assets/graphics/jpeg/smartParentsReferralRewardPrice/GuaranteedLearning_ReferralTable_EN_HKD.jpg';
import ForSmartParentsReferralPrice_EN_TWD from '../assets/graphics/jpeg/smartParentsReferralRewardPrice/GuaranteedLearning_ReferralTable_EN_TWD.jpg';
import ForSmartParentsReferralPrice_EN_USD from '../assets/graphics/jpeg/smartParentsReferralRewardPrice/GuaranteedLearning_ReferralTable_EN_USD.jpg';
import ForSmartParentsReferralPrice_JP_CNY from '../assets/graphics/jpeg/smartParentsReferralRewardPrice/GuaranteedLearning_ReferralTable_JP_CNY.jpg';
import ForSmartParentsReferralPrice_JP_HKD from '../assets/graphics/jpeg/smartParentsReferralRewardPrice/GuaranteedLearning_ReferralTable_JP_HKD.jpg';
import ForSmartParentsReferralPrice_JP_TWD from '../assets/graphics/jpeg/smartParentsReferralRewardPrice/GuaranteedLearning_ReferralTable_JP_TWD.jpg';
import ForSmartParentsReferralPrice_JP_USD from '../assets/graphics/jpeg/smartParentsReferralRewardPrice/GuaranteedLearning_ReferralTable_JP_USD.jpg';
import ForSmartParentsReferralPrice_SC_CNY from '../assets/graphics/jpeg/smartParentsReferralRewardPrice/GuaranteedLearning_ReferralTable_SC_CNY.jpg';
import ForSmartParentsReferralPrice_SC_HKD from '../assets/graphics/jpeg/smartParentsReferralRewardPrice/GuaranteedLearning_ReferralTable_SC_HKD.jpg';
import ForSmartParentsReferralPrice_SC_TWD from '../assets/graphics/jpeg/smartParentsReferralRewardPrice/GuaranteedLearning_ReferralTable_SC_TWD.jpg';
import ForSmartParentsReferralPrice_SC_USD from '../assets/graphics/jpeg/smartParentsReferralRewardPrice/GuaranteedLearning_ReferralTable_SC_USD.jpg';
import ForSmartParentsReferralPrice_TC_CNY from '../assets/graphics/jpeg/smartParentsReferralRewardPrice/GuaranteedLearning_ReferralTable_TC_CNY.jpg';
import ForSmartParentsReferralPrice_TC_HKD from '../assets/graphics/jpeg/smartParentsReferralRewardPrice/GuaranteedLearning_ReferralTable_TC_HKD.jpg';
import ForSmartParentsReferralPrice_TC_TWD from '../assets/graphics/jpeg/smartParentsReferralRewardPrice/GuaranteedLearning_ReferralTable_TC_TWD.jpg';
import ForSmartParentsReferralPrice_TC_USD from '../assets/graphics/jpeg/smartParentsReferralRewardPrice/GuaranteedLearning_ReferralTable_TC_USD.jpg';
import speakingGameBackground from '../assets/graphics/png/background/speaking_game_bg1_667x1450.png';
import ArkWord_Church_Kickstarter_IntegratedBanner_EN from '../assets/graphics/png/banners/ArkWord_Church_Kickstarter_IntegratedBanner_04_NoTitle.png';
import ArkWord_Church_Kickstarter_IntegratedBanner_JP from '../assets/graphics/png/banners/ArkWord_Church_Kickstarter_IntegratedBanner_JP_04_NoTitle.png';
import ArkWord_Church_Kickstarter_IntegratedBanner_SC from '../assets/graphics/png/banners/ArkWord_Church_Kickstarter_IntegratedBanner_SC_04_NoTitle.png';
import ArkWord_Church_Kickstarter_IntegratedBanner_TC from '../assets/graphics/png/banners/ArkWord_Church_Kickstarter_IntegratedBanner_TC_04_NoTitle.png';
import BannerBackgroundEffect from '../assets/graphics/png/banners/banner_background_effect.png';
import BibleBoosterBG from '../assets/graphics/png/banners/bibleBoosterBG.png';
import Charity from '../assets/graphics/png/banners/charity.png';
import Facebook_Ad_WorldCupBible_2024_03 from '../assets/graphics/png/banners/Facebook_Ad_WorldCupBible_2024_03.png';
import ForWeb_BusinessEng_Competition_2024_Banner from '../assets/graphics/png/banners/ForWeb_BusinessEng_Competition_2024_Banner02.png';
import ForWeb_ESG_Competition_2024_Banner from '../assets/graphics/png/banners/ForWeb_ESG_Competition_2024_Banner02.png';
import ForWeb_FunEng_Competition_2024_Banner from '../assets/graphics/png/banners/ForWeb_FunEng_Competition_2024_Banner02.png';
import JOYAJOY_IntegratedPhones_MemoryGameTypes from '../assets/graphics/png/banners/JOYAJOY_IntegratedPhones_MemoryGameTypesv2_Crop.png';
import ScoreA from '../assets/graphics/png/banners/scoreA.png';
import DownloadFromAppStore from '../assets/graphics/png/download/Yfc020c87j0.png';
import Crown from '../assets/graphics/png/games/crown.png';
import CrownEffect from '../assets/graphics/png/games/crown_effect.png';
import HandwriteFinger from '../assets/graphics/png/games/Handwrite_finger.png';
import ESG_E from '../assets/graphics/png/icons/esg/e.png';
import ESG_G from '../assets/graphics/png/icons/esg/g.png';
import ESG_S from '../assets/graphics/png/icons/esg/s.png';
import ForReferralRewards_img1_EN from '../assets/graphics/png/ReferralRewards_Detail/img1_en.png';
import ForReferralRewards_img1_JP from '../assets/graphics/png/ReferralRewards_Detail/img1_jp.png';
import ForReferralRewards_img1_SC from '../assets/graphics/png/ReferralRewards_Detail/img1_sc.png';
import ForReferralRewards_img1_TC from '../assets/graphics/png/ReferralRewards_Detail/img1_tc.png';
import ForReferralRewards_img2_EN from '../assets/graphics/png/ReferralRewards_Detail/img2_en.png';
import ForReferralRewards_img2_JP from '../assets/graphics/png/ReferralRewards_Detail/img2_jp.png';
import ForReferralRewards_img2_SC from '../assets/graphics/png/ReferralRewards_Detail/img2_sc.png';
import ForReferralRewards_img2_TC from '../assets/graphics/png/ReferralRewards_Detail/img2_tc.png';
import ForReferralRewards_img3_EN from '../assets/graphics/png/ReferralRewards_Detail/img3_en.png';
import ForReferralRewards_img3_JP from '../assets/graphics/png/ReferralRewards_Detail/img3_jp.png';
import ForReferralRewards_img3_SC from '../assets/graphics/png/ReferralRewards_Detail/img3_sc.png';
import ForReferralRewards_img3_TC from '../assets/graphics/png/ReferralRewards_Detail/img3_tc.png';
import ForReferralRewards_img4_EN from '../assets/graphics/png/ReferralRewards_Detail/img4_en.png';
import ForReferralRewards_img4_JP from '../assets/graphics/png/ReferralRewards_Detail/img4_jp.png';
import ForReferralRewards_img4_SC from '../assets/graphics/png/ReferralRewards_Detail/img4_sc.png';
import ForReferralRewards_img4_TC from '../assets/graphics/png/ReferralRewards_Detail/img4_tc.png';
import AnnieLaw from '../assets/graphics/png/smart_program_detail/AnnieLaw.png';
// smart parents program images
import ForSmartParents_img1 from '../assets/graphics/png/smart_program_detail/img1.png';
import ForSmartParents_img2_EN from '../assets/graphics/png/smart_program_detail/img2_EN.png';
import ForSmartParents_img3_EN from '../assets/graphics/png/smart_program_detail/img3_EN.png';
import ForSmartParents_img3_TC from '../assets/graphics/png/smart_program_detail/img3_TC.png';
import ForSmartParents_img4 from '../assets/graphics/png/smart_program_detail/img4.png';
import ForSmartParents_img5 from '../assets/graphics/png/smart_program_detail/img5.png';
import ForSmartParents_img6 from '../assets/graphics/png/smart_program_detail/img6.png';
import ForSmartParents_img7 from '../assets/graphics/png/smart_program_detail/img7.png';
import ForSmartParents_img8_EN from '../assets/graphics/png/smart_program_detail/img8_EN.png';
import ForSmartParents_img8_JP from '../assets/graphics/png/smart_program_detail/img8_JP.png';
import ForSmartParents_img8_SC from '../assets/graphics/png/smart_program_detail/img8_SC.png';
import ForSmartParents_img8_TC from '../assets/graphics/png/smart_program_detail/img8_TC.png';
import ForSmartParents_img9_JP from '../assets/graphics/png/smart_program_detail/img9_JP.png';
import ForSmartParents_img9_SC from '../assets/graphics/png/smart_program_detail/img9_SC.png';
import ForSmartParents_img10 from '../assets/graphics/png/smart_program_detail/img10.png';
import ForSmartParents_img11 from '../assets/graphics/png/smart_program_detail/img11.png';
import ForSmartParents_img13_EN from '../assets/graphics/png/smart_program_detail/img13_EN.jpg';
import ForSmartParents_img13_JP from '../assets/graphics/png/smart_program_detail/img13_JP.jpg';
import ForSmartParents_img13_SC from '../assets/graphics/png/smart_program_detail/img13_SC.jpg';
import ForSmartParents_img13_TC from '../assets/graphics/png/smart_program_detail/img13_TC.jpg';
import ForSmartParents_img14 from '../assets/graphics/png/smart_program_detail/img14.png';
import ForSmartParents_img15 from '../assets/graphics/png/smart_program_detail/img15.jpeg';
import WEA_Web_IMG_HowToRefer01_EN from '../assets/graphics/png/WEA/WEA_Web_IMG_HowToRefer01_EN.png';
import WEA_Web_IMG_HowToRefer01_JP from '../assets/graphics/png/WEA/WEA_Web_IMG_HowToRefer01_JP.png';
import WEA_Web_IMG_HowToRefer01_SC from '../assets/graphics/png/WEA/WEA_Web_IMG_HowToRefer01_SC.png';
import WEA_Web_IMG_HowToRefer01_TC from '../assets/graphics/png/WEA/WEA_Web_IMG_HowToRefer01_TC.png';
import WEA_Web_IMG_HowToRefer02_EN from '../assets/graphics/png/WEA/WEA_Web_IMG_HowToRefer02_EN.png';
import WEA_Web_IMG_HowToRefer02_JP from '../assets/graphics/png/WEA/WEA_Web_IMG_HowToRefer02_JP.png';
import WEA_Web_IMG_HowToRefer02_SC from '../assets/graphics/png/WEA/WEA_Web_IMG_HowToRefer02_SC.png';
import WEA_Web_IMG_HowToRefer02_TC from '../assets/graphics/png/WEA/WEA_Web_IMG_HowToRefer02_TC.png';
import WEA_Web_IMG_HowToRefer03_EN from '../assets/graphics/png/WEA/WEA_Web_IMG_HowToRefer03_EN.png';
import WEA_Web_IMG_HowToRefer03_JP from '../assets/graphics/png/WEA/WEA_Web_IMG_HowToRefer03_JP.png';
import WEA_Web_IMG_HowToRefer03_SC from '../assets/graphics/png/WEA/WEA_Web_IMG_HowToRefer03_SC.png';
import WEA_Web_IMG_HowToRefer03_TC from '../assets/graphics/png/WEA/WEA_Web_IMG_HowToRefer03_TC.png';
import WEA_Web_IMG_HowToRefer04_EN from '../assets/graphics/png/WEA/WEA_Web_IMG_HowToRefer04_EN.png';
import WEA_Web_IMG_HowToRefer04_JP from '../assets/graphics/png/WEA/WEA_Web_IMG_HowToRefer04_JP.png';
import WEA_Web_IMG_HowToRefer04_SC from '../assets/graphics/png/WEA/WEA_Web_IMG_HowToRefer04_SC.png';
import WEA_Web_IMG_HowToRefer04_TC from '../assets/graphics/png/WEA/WEA_Web_IMG_HowToRefer04_TC.png';
import WEA_Web_IMG_ReferRewardTime_EN from '../assets/graphics/png/WEA/WEA_Web_IMG_ReferRewardTime_EN.png';
import WEA_Web_IMG_ReferRewardTime_JP from '../assets/graphics/png/WEA/WEA_Web_IMG_ReferRewardTime_JP.png';
import WEA_Web_IMG_ReferRewardTime_SC from '../assets/graphics/png/WEA/WEA_Web_IMG_ReferRewardTime_SC.png';
import WEA_Web_IMG_ReferRewardTime_TC from '../assets/graphics/png/WEA/WEA_Web_IMG_ReferRewardTime_TC.png';
import WEA_Web_IMG_WEACash01 from '../assets/graphics/png/WEA/WEA_Web_IMG_WEACash01.png';
import WEA_Web_IMG_WEACash02 from '../assets/graphics/png/WEA/WEA_Web_IMG_WEACash02.png';
import WorldEducatorsA_Logo_202010_Horizontal_WEA_Eng from '../assets/graphics/png/WEA/WorldEducatorsA_Logo_202010_Horizontal_WEA_Eng.png';
import ForWEAProgram_img1 from '../assets/graphics/png/WEA_Program_Detail/img1.png';
import ForWEAProgram_img2 from '../assets/graphics/png/WEA_Program_Detail/img2.png';
import ForWEAProgram_img3 from '../assets/graphics/png/WEA_Program_Detail/img3.png';
import ForWEAProgram_img4 from '../assets/graphics/png/WEA_Program_Detail/img4.png';
import ForWEAProgram_img5 from '../assets/graphics/png/WEA_Program_Detail/img5.png';
import ForWEAProgram_img6 from '../assets/graphics/png/WEA_Program_Detail/img6.png';
import ForWEAProgram_img7 from '../assets/graphics/png/WEA_Program_Detail/img7.png';
import ForWEAProgram_img8 from '../assets/graphics/png/WEA_Program_Detail/img8.png';
import AIClub from '../assets/graphics/webp/banners/aiclub.webp';
import Club from '../assets/graphics/webp/banners/club.webp';
import Farmland from '../assets/graphics/webp/banners/farmland.webp';
import NameCard from '../assets/graphics/webp/banners/namecard.webp';
import { UiLocale } from '../models/Base';
import { GameType } from '../models/GameStore/Game';

export const Images = {
  //JOYAJOY
  JOYAJOY_logo_Horizontal_Logo_Slogan_ForDarkBG_TC,
  JOYAJOY_logo_Horizontal_Logo_Slogan_ForDarkBG_EN,
  JOYAJOY_logo_Horizontal_Logo_Slogan_ForDarkBG_SC,
  JOYAJOY_logo_Horizontal_Logo_Slogan_ForDarkBG_JP,

  Icon_JOYAJOY_Website_Bot_AIRevisionSystem_EN,
  Icon_JOYAJOY_Website_Bot_AIRevisionSystem_JP,
  Icon_JOYAJOY_Website_Bot_AIRevisionSystem_SC,
  Icon_JOYAJOY_Website_Bot_AIRevisionSystem_TC,

  JOYAJOY_logo,
  JOYAJOY_logo_Text_Slogan_EN,
  JOYAJOY_logo_Text_Slogan_TC,
  JOYAJOY_logo_Text_Slogan_SC,
  JOYAJOY_logo_Text_Slogan_JP,

  JoyajoyLightModeLogo,
  JoyajoyLightModeNoRLogo, // use when the (R) is too small to see
  JoyajoyDarkModeLogo,
  JoyajoyDarkModeNoRLogo, // use when the (R) is too small to see
  //
  For_web_video_preview_AIMemoryBoosterGuide_EN,
  For_web_video_preview_AIMemoryBoosterGuide_TC,
  For_web_video_preview_BibleBoosterGuide_EN,
  For_web_video_preview_BibleBoosterGuide_TC,
  For_web_video_preview_Smart_Parent_Program_EN,
  For_web_video_preview_Smart_Parent_Program_SC,
  For_web_video_preview_Smart_Parent_Program_TC,
  For_web_video_preview_Text_To_Game_EN,
  For_web_video_preview_Text_To_Game_SC,
  For_web_video_preview_Text_To_Game_TC,

  DownloadFromAppStore,

  // webp
  Club,
  AIClub,
  NameCard,
  Farmland,

  // gif
  Club_GIF,
  AIClub_GIF,
  NameCard_GIF,
  Farmland_GIF,

  // png
  ESG_E,
  ESG_S,
  ESG_G,
  Charity,

  // game background
  speakingGameBackground,

  //Promotions
  JOYAJOY_IntegratedPhones_MemoryGameTypes,
  ArkWord_Church_Kickstarter_IntegratedBanner_TC,
  ArkWord_Church_Kickstarter_IntegratedBanner_SC,
  ArkWord_Church_Kickstarter_IntegratedBanner_JP,
  ArkWord_Church_Kickstarter_IntegratedBanner_EN,
  Facebook_Ad_WorldCupBible_2024_03,
  ForWeb_BusinessEng_Competition_2024_Banner,
  ForWeb_ESG_Competition_2024_Banner,
  ForWeb_FunEng_Competition_2024_Banner,

  //Games
  HandwriteFinger,
  CrownEffect,
  Crown,
  // smart parents program images
  ForSmartParents_img1,
  ForSmartParents_img2_EN,
  ForSmartParents_img3_EN,
  ForSmartParents_img3_TC,
  ForSmartParents_img4,
  ForSmartParents_img5,
  ForSmartParents_img6,
  ForSmartParents_img7,
  ForSmartParents_img8_EN,
  ForSmartParents_img8_JP,
  ForSmartParents_img8_SC,
  ForSmartParents_img8_TC,
  ForSmartParents_img9_JP,
  ForSmartParents_img9_SC,
  ForSmartParents_img10,
  ForSmartParents_img11,
  ForSmartParents_img13_EN,
  ForSmartParents_img13_TC,
  ForSmartParents_img13_SC,
  ForSmartParents_img13_JP,
  ForSmartParents_img14,
  AnnieLaw,
  ForSmartParents_img15,
  // Create Game Banner
  QuickMemoryJOY_01,
  QuickMemoryJOY_02,
  QuickMemoryJOY_03,
  QuickMemoryJOY_04,
  SpellingJOYByLetters_01,
  SpellingJOYBySyllables_01,
  QuickHandwritingJOY_01,
  QuickHandwritingJOY_02,
  // WEA Referral Reward Details Banner
  WEA_Web_IMG_HowToRefer01_EN,
  WEA_Web_IMG_HowToRefer01_JP,
  WEA_Web_IMG_HowToRefer01_SC,
  WEA_Web_IMG_HowToRefer01_TC,
  WEA_Web_IMG_HowToRefer02_EN,
  WEA_Web_IMG_HowToRefer02_JP,
  WEA_Web_IMG_HowToRefer02_SC,
  WEA_Web_IMG_HowToRefer02_TC,
  WEA_Web_IMG_HowToRefer03_EN,
  WEA_Web_IMG_HowToRefer03_JP,
  WEA_Web_IMG_HowToRefer03_SC,
  WEA_Web_IMG_HowToRefer03_TC,
  WEA_Web_IMG_HowToRefer04_EN,
  WEA_Web_IMG_HowToRefer04_JP,
  WEA_Web_IMG_HowToRefer04_SC,
  WEA_Web_IMG_HowToRefer04_TC,
  WEA_Web_IMG_ReferRewardTime_EN,
  WEA_Web_IMG_ReferRewardTime_JP,
  WEA_Web_IMG_ReferRewardTime_SC,
  WEA_Web_IMG_ReferRewardTime_TC,
  WEA_Web_IMG_WEACash01,
  WEA_Web_IMG_WEACash02,
  WorldEducatorsA_Logo_202010_Horizontal_WEA_Eng,

  ForWEAProgram_img1,
  ForWEAProgram_img2,
  ForWEAProgram_img3,
  ForWEAProgram_img4,
  ForWEAProgram_img5,
  ForWEAProgram_img6,
  ForWEAProgram_img7,
  ForWEAProgram_img8,

  ForSmartParentsReferralPrice_EN_CNY,
  ForSmartParentsReferralPrice_EN_HKD,
  ForSmartParentsReferralPrice_EN_TWD,
  ForSmartParentsReferralPrice_EN_USD,
  ForSmartParentsReferralPrice_JP_CNY,
  ForSmartParentsReferralPrice_JP_HKD,
  ForSmartParentsReferralPrice_JP_TWD,
  ForSmartParentsReferralPrice_JP_USD,
  ForSmartParentsReferralPrice_SC_CNY,
  ForSmartParentsReferralPrice_SC_HKD,
  ForSmartParentsReferralPrice_SC_TWD,
  ForSmartParentsReferralPrice_SC_USD,
  ForSmartParentsReferralPrice_TC_CNY,
  ForSmartParentsReferralPrice_TC_HKD,
  ForSmartParentsReferralPrice_TC_TWD,
  ForSmartParentsReferralPrice_TC_USD,

  ForReferralRewards_img1_EN,
  ForReferralRewards_img1_JP,
  ForReferralRewards_img1_SC,
  ForReferralRewards_img1_TC,
  ForReferralRewards_img2_EN,
  ForReferralRewards_img2_JP,
  ForReferralRewards_img2_SC,
  ForReferralRewards_img2_TC,
  ForReferralRewards_img3_EN,
  ForReferralRewards_img3_JP,
  ForReferralRewards_img3_SC,
  ForReferralRewards_img3_TC,
  ForReferralRewards_img4_EN,
  ForReferralRewards_img4_JP,
  ForReferralRewards_img4_SC,
  ForReferralRewards_img4_TC,

  For_web_video_preview_Case_Study_TC,
  For_web_video_preview_Case_Study_SC,

  BannerBackgroundEffect,
  ScoreA,
  BibleBoosterBG,

  Donation_01_Bread,
  Donation_01_Giving,
  Donation_01_Hungry,
  Donation_01_Staff,
  Donation_02_Bread,
  Donation_02_Giving,
  Donation_02_Hungry,
  Donation_02_Staff,
  Donation_03_Bread,
  Donation_03_Giving,
  Donation_03_Hungry,
  Donation_03_Staff,
  Donation_04_Bread,
  Donation_04_Giving,
  Donation_04_Hungry,
  Donation_04_Staff,
  Donation_05_Bread,
  Donation_05_Giving,
  Donation_05_Hungry,
  Donation_05_Staff,
  Donation_06_Bread,
  Donation_06_Giving,
  Donation_06_Hungry,
  Donation_06_Staff,
  Donation_07_Bread,
  Donation_07_Giving,
  Donation_07_Hungry,
  Donation_07_Staff,

  Guide_01,
  Guide_02,
  Guide_03,
  Guide_04,
  GuideAn_01,
  GuideAn_02,
  GuideAn_03,
  GuideAn_04,
  GuideAn_05,
};

export const getSmartParentsImage = (
  // generated code
  imageName: string,
  lang: UiLocale,
): string | undefined => {
  type LanguageCode = UiLocale;
  type LanguageSuffix = 'SC' | 'TC' | 'JP' | 'EN';
  const languageMap: Record<LanguageCode, LanguageSuffix> = {
    [UiLocale.CN]: 'SC',
    [UiLocale.HK]: 'TC',
    [UiLocale.TW]: 'TC',
    [UiLocale.JP]: 'JP',
    [UiLocale.US]: 'EN',
  };

  const languageSuffix: LanguageSuffix = languageMap[lang] || 'EN';

  // Define a function to get priority list based on the language
  const getPriorityList = (suffix: LanguageSuffix): LanguageSuffix[] => {
    if (suffix === 'SC' || suffix === 'TC') {
      return [suffix, suffix === 'SC' ? 'TC' : 'SC', 'EN', 'JP'];
    } else {
      return [suffix, 'EN', 'SC', 'TC', 'JP'];
    }
  };

  const suffixPriority = getPriorityList(languageSuffix);

  // Remove duplicates from the priority list
  const uniqueSuffixes = Array.from(new Set(suffixPriority));

  // Try each suffix in the priority order
  for (const suffix of uniqueSuffixes) {
    const imageKey =
      `ForSmartParents_${imageName}_${suffix}` as keyof typeof Images;
    if (imageKey in Images) {
      return Images[imageKey];
    }
  }

  // If no language-specific version exists, try without language suffix
  const defaultImageKey = `ForSmartParents_${imageName}` as keyof typeof Images;
  if (defaultImageKey in Images) {
    return Images[defaultImageKey];
  }

  return undefined;
};

export const getWEAProgramImage = (imageName: string): string | undefined => {
  const imageKey = `ForWEAProgram_${imageName}` as keyof typeof Images;
  if (imageKey in Images) {
    return Images[imageKey];
  }
  return undefined;
};

export const getSmartParentsReferralPriceImage = (
  lang: UiLocale,
  currency: string,
): string | undefined => {
  let code = '';
  switch (lang) {
    case UiLocale.CN:
      code = 'SC';
      break;
    case UiLocale.HK:
    case UiLocale.TW:
      code = 'TC';
      break;
    case UiLocale.JP:
      code = 'JP';
      break;
    case UiLocale.US:
    default:
      code = 'EN';
      break;
  }
  const imageName = `ForSmartParentsReferralPrice_${code}_${currency}`;
  return (
    (Images as Record<string, string>)[imageName] ||
    Images.ForSmartParentsReferralPrice_EN_USD ||
    undefined
  );
};

export const getImageCustomName = (
  lang: UiLocale,
  name: string,
): string | undefined => {
  let code = '';
  switch (lang) {
    case UiLocale.CN:
      code = 'SC';
      break;
    case UiLocale.HK:
    case UiLocale.TW:
      code = 'TC';
      break;
    case UiLocale.JP:
      code = 'JP';
      break;
    case UiLocale.US:
    default:
      code = 'EN';
      break;
  }
  const imageName = `${name}_${code}`;
  return (
    (Images as Record<string, string>)[imageName] ||
    (Images as Record<string, string>)[`${name}_EN`] ||
    undefined
  );
};

export const getDonationImage = (
  set: number,
  type?: 'hungry' | 'staff' | 'giving' | 'bread',
) => {
  const images = [
    {
      bread: Images.Donation_01_Bread,
      giving: Images.Donation_01_Giving,
      hungry: Images.Donation_01_Hungry,
      staff: Images.Donation_01_Staff,
    },
    {
      bread: Images.Donation_02_Bread,
      giving: Images.Donation_02_Giving,
      hungry: Images.Donation_02_Hungry,
      staff: Images.Donation_02_Staff,
    },
    {
      bread: Images.Donation_03_Bread,
      giving: Images.Donation_03_Giving,
      hungry: Images.Donation_03_Hungry,
      staff: Images.Donation_03_Staff,
    },
    {
      bread: Images.Donation_04_Bread,
      giving: Images.Donation_04_Giving,
      hungry: Images.Donation_04_Hungry,
      staff: Images.Donation_04_Staff,
    },
    {
      bread: Images.Donation_05_Bread,
      giving: Images.Donation_05_Giving,
      hungry: Images.Donation_05_Hungry,
      staff: Images.Donation_05_Staff,
    },
    {
      bread: Images.Donation_06_Bread,
      giving: Images.Donation_06_Giving,
      hungry: Images.Donation_06_Hungry,
      staff: Images.Donation_06_Staff,
    },
    {
      bread: Images.Donation_07_Bread,
      giving: Images.Donation_07_Giving,
      hungry: Images.Donation_07_Hungry,
      staff: Images.Donation_07_Staff,
    },
  ];
  return images[set % images.length]![type ?? 'hungry'];
};

import FingerWritingGameBackground from '../assets/graphics/png/background/handwriting_game_bg1_667x1450.png';
// import MatchingGameBackground from '../assets/graphics/png/background/matching_game_bg2_667x1450.png';
// import MultipleChoiceGameBackground from '../assets/graphics/png/background/matching_game_bg_667x1450.png';
import TextOrderingGameBackground from '../assets/graphics/png/background/speaking_game_bg1_667x1450.png';
// import {
//   default as PairingGameBackground,
//   default as TextOrderingGameBackground,
// } from '../assets/graphics/png/background/speaking_game_bg1_667x1450.png';
// import OrderingGameBackground from '../assets/graphics/png/background/speaking_game_bg2_667x1450.png';
// import ConversationGameBackground from '../assets/graphics/png/background/speaking_game_bg3_667x1450.png';
// import ManuallyEvaluatedConversationGameBackground from '../assets/graphics/png/background/spelling_game_bg1_667x1450.png';
// import SpeakingGameBackground from '../assets/graphics/png/background/spelling_game_bg2_667x1450.png';

export const GamePreviewImageMap = Object.freeze<Record<GameType, string>>({
  [GameType.TextOrdering]: TextOrderingGameBackground,
  [GameType.FingerWriting]: FingerWritingGameBackground,
  // [GameType.MultipleChoice]: MultipleChoiceGameBackground,
  // [GameType.Pairing]: PairingGameBackground,
  // [GameType.Conversation]: ConversationGameBackground,
  // [GameType.ManuallyEvaluatedConversation]:
  //   ManuallyEvaluatedConversationGameBackground,
  // [GameType.Ordering]: OrderingGameBackground,
  // [GameType.Matching]: MatchingGameBackground,
  // [GameType.Speaking]: SpeakingGameBackground,
});

// Images by lang

export const getTextToGameVideoPreview = (lang: UiLocale) => {
  switch (lang) {
    case UiLocale.CN:
      return Images.For_web_video_preview_Text_To_Game_SC;
    case UiLocale.HK:
    case UiLocale.TW:
      return Images.For_web_video_preview_Text_To_Game_TC;
    case UiLocale.JP:
      return Images.For_web_video_preview_Text_To_Game_EN;
    case UiLocale.US:
    default:
      return Images.For_web_video_preview_Text_To_Game_EN;
  }
};

export const getMemoryBoostCreateVideoPreview = (lang: UiLocale) => {
  switch (lang) {
    case UiLocale.CN:
    case UiLocale.HK:
    case UiLocale.TW:
      return Images.For_web_video_preview_AIMemoryBoosterGuide_TC;
    case UiLocale.JP:
    case UiLocale.US:
    default:
      return Images.For_web_video_preview_AIMemoryBoosterGuide_EN;
  }
};

export const getBibleBoostCreateVideoPreview = (lang: UiLocale) => {
  switch (lang) {
    case UiLocale.CN:
    case UiLocale.HK:
    case UiLocale.TW:
      return Images.For_web_video_preview_BibleBoosterGuide_TC;
    case UiLocale.JP:
    case UiLocale.US:
    default:
      return Images.For_web_video_preview_BibleBoosterGuide_EN;
  }
};

export const getIconJOYAJOYWebsiteBotAIRevisionSystem = (lang: UiLocale) => {
  switch (lang) {
    case UiLocale.CN:
      return Images.Icon_JOYAJOY_Website_Bot_AIRevisionSystem_SC;
    case UiLocale.HK:
    case UiLocale.TW:
      return Images.Icon_JOYAJOY_Website_Bot_AIRevisionSystem_TC;
    case UiLocale.JP:
      return Images.Icon_JOYAJOY_Website_Bot_AIRevisionSystem_JP;
    case UiLocale.US:
    default:
      return Images.Icon_JOYAJOY_Website_Bot_AIRevisionSystem_EN;
  }
};

export const getSmartParentProgramVideoPreview = (lang: UiLocale) => {
  switch (lang) {
    case UiLocale.CN:
      return Images.For_web_video_preview_Smart_Parent_Program_SC;
    case UiLocale.HK:
    case UiLocale.TW:
      return Images.For_web_video_preview_Smart_Parent_Program_TC;
    case UiLocale.JP:
      return Images.For_web_video_preview_Smart_Parent_Program_EN;
    case UiLocale.US:
    default:
      return Images.For_web_video_preview_Smart_Parent_Program_EN;
  }
};

export const getJOYAJOYLogoHorizontalLogoSloganForDarkBGImage = (
  lang: UiLocale,
) => {
  switch (lang) {
    case UiLocale.CN:
      return Images.JOYAJOY_logo_Horizontal_Logo_Slogan_ForDarkBG_SC;
    case UiLocale.HK:
    case UiLocale.TW:
      return Images.JOYAJOY_logo_Horizontal_Logo_Slogan_ForDarkBG_TC;
    case UiLocale.JP:
      return Images.JOYAJOY_logo_Horizontal_Logo_Slogan_ForDarkBG_JP;
    case UiLocale.US:
    default:
      return Images.JOYAJOY_logo_Horizontal_Logo_Slogan_ForDarkBG_EN;
  }
};
